// @ts-nocheck
/**
 * Utility functions for ContentsItem component
 * @module utils/contentsItemUtils
 */

/**
 * Get color for workflow state
 * @param {string} string - The workflow state
 * @returns {string} - The corresponding color
 */
export function getColor(string) {
  switch (string) {
    case 'private':
      return '#ed4033';
    case 'published':
      return '#007bc1';
    case 'intranet':
      return '#51aa55';
    case 'draft':
      return '#f6a808';
    default:
      return 'grey';
  }
}

/**
 * Convert bytes to human readable format
 * @param {number} bytes - The number of bytes
 * @returns {string} - Human readable size string
 */
export const niceBytes = (bytes) => {
  bytes = Number(bytes);

  const divider = 1024;
  const magnitude = (Math.log(bytes) / Math.log(divider)) | 0;
  const result = bytes / Math.pow(divider, magnitude);
  const fixed = result.toFixed(0);

  const suffix = magnitude ? 'kMGTPEZY'[magnitude - 1] + 'B' : 'B';

  return fixed + suffix;
};

/**
 * Helper function to check if value is truly empty
 * @param {*} value - The value to check
 * @returns {boolean} - True if value has content, false if empty
 */
export const hasValue = (value) => {
  if (!value) return false;
  if (Array.isArray(value) && value.length === 0) return false;
  if (typeof value === 'string' && value.trim() === '') return false;
  return true;
};
